import { render, staticRenderFns } from "./VerifyEmailChange.vue?vue&type=template&id=22ab3fda&scoped=true"
import script from "./VerifyEmailChange.vue?vue&type=script&lang=js"
export * from "./VerifyEmailChange.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmailChange.vue?vue&type=style&index=0&id=22ab3fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ab3fda",
  null
  
)

export default component.exports